import { render } from "./highlightEdit.vue?vue&type=template&id=3021db0b&scoped=true"
import script from "./highlightEdit.vue?vue&type=script&lang=js"
export * from "./highlightEdit.vue?vue&type=script&lang=js"

import "./highlightEdit.vue?vue&type=style&index=0&id=3021db0b&scoped=true&lang=css"

import exportComponent from "/Users/hamzaassif/Work/detect-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3021db0b"]])

export default __exports__